import { Component, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { VersionService } from './core/services/version.service';
import { ExternalScriptsService } from './core/services/external-scripts.service';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private versionService = inject(VersionService);
  private externalScriptsService = inject(ExternalScriptsService);
  private authService = inject(AuthService);
  private router = inject(Router);

  private lastPermissionsRefresh = 0;
  private readonly PERMISSIONS_REFRESH_INTERVAL_MS = 2 * 60 * 1000;

  ngOnInit(): void {
    // Reset the dismissed state when the app initializes
    this.versionService.resetDismissedState();

    // Check for version mismatch
    this.versionService.checkVersion().subscribe();

    // Start listening for app updates
    this.versionService.initUpdateListener();

    this.authService.user$.subscribe(() => {
      if (this.authService.isAuthenticated()) {
        this.externalScriptsService.removeScript('widget-no-login');
        this.externalScriptsService.loadLoggedWidget();
      }
      else {
        this.externalScriptsService.removeScript('widget-login');
        this.externalScriptsService.loadNotLoggedWidget();
      }
    });

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        if (!this.authService.isAuthenticated()) { return; }
        const now = Date.now();
        if (now - this.lastPermissionsRefresh >= this.PERMISSIONS_REFRESH_INTERVAL_MS) {
          this.lastPermissionsRefresh = now;
          this.authService.refreshPermissions().subscribe();
        }
      });
  }

}
